var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1143_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 21.214C24.5527 21.214 25.0004 21.6618 25.0004 22.214C25.0004 22.7661 24.5527 23.2139 24.0005 23.2139H21.0175H21.0001H4.00029H3.98288H0.999917C0.447724 23.2139 0 22.7661 0 22.214C0 21.6618 0.447724 21.214 0.999917 21.214H2.99975V12.7141C2.99975 10.1005 4.06807 7.72511 5.78932 6.00386C6.99631 4.79687 8.52479 3.91075 10.2317 3.48914C10.0943 3.18133 10.0184 2.83994 10.0184 2.48114C10.0184 1.1106 11.1291 0 12.4996 0C13.8701 0 14.9807 1.1106 14.9807 2.48114C14.9807 2.83994 14.9042 3.18133 14.7674 3.48914C16.4744 3.91075 18.0029 4.79687 19.2099 6.00386C20.9311 7.72511 21.9994 10.1005 21.9994 12.7141V21.214H23.9993H24.0005ZM12.5002 23.8475C14.1991 23.8475 15.5764 25.2249 15.5764 26.9238C15.5764 28.6226 14.1991 30 12.5002 30C10.8013 30 9.42397 28.6226 9.42397 26.9238C9.42397 25.2249 10.8013 23.8475 12.5002 23.8475ZM5.00021 21.214H20.0002V12.7141C20.0002 10.6527 19.1564 8.77788 17.7964 7.41792C16.4364 6.05796 14.5616 5.21412 12.5002 5.21412C10.4388 5.21412 8.56334 6.05796 7.204 7.41792C5.84404 8.77788 5.00021 10.6527 5.00021 12.7141V21.214Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1143_648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 5,
    fill: "#C30306"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1143_648",
    x: 10,
    y: -5,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1143_648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1143_648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1143_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon1);
export default __webpack_public_path__ + "static/media/bellicon1.5f25108a6dad7728a920184d1e2ce21d.svg";
export { ForwardRef as ReactComponent };